export default __webpack_public_path__ + "static/media/Illu-pastille-flag.c7ef6f26.png";